import i, { useState as a, useEffect as T } from "react";
import { loadStripe as F } from "./index5.mjs";
import { Elements as L } from "./index6.mjs";
import { StripeForm as w } from "./index7.mjs";
import { DEFAULT_PAYMENT_COLOR as B } from "./index8.mjs";
const O = ({
  clientSecret: r,
  expressPublicKey: o,
  amount: d,
  currency: m,
  country: s,
  stripeObjectType: n,
  onError: t,
  onSuccess: p,
  className: u,
  primaryColor: E,
  locale: f = "auto",
  showSalesTerms: g,
  showTermsAndConditions: S
}) => {
  const _ = [
    r,
    o,
    m,
    s,
    n
  ].every(Boolean), [v, A] = a(!1), [l, P] = a(null);
  return T(() => {
    const e = F(o, {
      locale: f
    });
    if (!e && t) {
      t(new Error("Stripe promise function not found"));
      return;
    }
    P(e);
  }, [t, o, f]), !l || !_ ? null : /* @__PURE__ */ i.createElement(
    "div",
    {
      style: {
        "--primary-color": E || B
      }
    },
    /* @__PURE__ */ i.createElement(
      L,
      {
        stripe: l,
        options: {
          clientSecret: r
        }
      },
      /* @__PURE__ */ i.createElement(
        w,
        {
          clientSecret: r,
          country: s,
          stripeObjectType: n,
          amount: d,
          currency: m,
          onSuccess: (e) => {
            p && p(e), A(!0);
          },
          onError: (e) => {
            t && t(e);
          },
          className: u,
          isTriggered: v,
          showSalesTerms: g,
          showTermsAndConditions: S
        }
      )
    )
  );
};
export {
  O as StripeElement
};
